import React from 'react'

const Background = (props) => {
    return(
        <img src={props.src} alt="Hart Communication" className="bg-image"/>
    )
}

export default Background


// WEBPACK FOOTER //
// ./src/components/common/Background.js